// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

const defaultLang = process.env.REACT_APP_REGION !== "CA" ? "en" : "";

i18n
    .use(HttpBackend) // loads translations from your public folder
    .use(LanguageDetector) // detects browser language
    .use(initReactI18next) // passes i18n instance to react-i18next
    .init({
    lng: defaultLang,
    fallbackLng: 'en',
    debug: true, // set to false in production
    interpolation: {
        escapeValue: false, // react already escapes
    },
    backend: {
        loadPath: '/locales/{{lng}}/translation.json',
    }
  });

  export const languageOptions = [
    {value: 'en', label: 'English'},
    {value: 'fr', label: 'Français'}
  ];

  export const getSelectedLanguageOption = (lng) =>
    languageOptions.find(opt => opt.value === lng?.split('-')[0].toLowerCase()) ?? languageOptions[0];

export default i18n;
